import GoogleSVG from '@assets/img/svg/google.svg'
import Button from '@components/buttons/button/button.component'
import { withTransaction } from '@elastic/apm-rum-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import './firebase-connect.component.scoped.scss'

export type Provider = 'google'

interface Props {
  providers: Array<Provider>
  onSelectedProvider: (provider: Provider) => Provider
  loading?: boolean
}

interface ProviderConfig {
  [key: string]: {
    key: string
    name: string
    icon: string
    color: string
    colorIcon: string
    action: () => void
  }
}

const FirebaseConnect = ({ providers, onSelectedProvider, loading = false }: Props) => {
  const { t } = useTranslation('firebaseConnect')

  const providersConfig: ProviderConfig = useMemo(
    () => ({
      google: {
        key: 'google',
        name: 'Google',
        icon: GoogleSVG,
        color: 'var(--background_secondary)',
        colorIcon: 'red',
        action: () => onSelectedProvider('google'),
      },
    }),
    [onSelectedProvider]
  )

  return (
    <div className="social-connect py-3">
      {providers?.map((provider) => (
        <Button
          key={providersConfig?.[provider]?.key}
          className={`social-connect-${provider}`}
          size="lg"
          color={providersConfig?.[provider]?.color}
          textColor="var(--text_color)"
          width="100%"
          style={{ borderWidth: '1px', borderRadius: '8px' }}
          onClick={providersConfig[provider].action}
          borderColor="var(--border_color)"
          disabled={loading}
          loaderColor="var(--text_color)"
        >
          <div className="button-container display-flex justify-content-center align-items-center px-4 py-1 position-relative">
            <img
              src={providersConfig?.[provider]?.icon}
              alt={providersConfig?.[provider]?.name}
              className="position-absolute"
              style={{ left: 0 }}
            />
            <span>{t('signIn', { provider: providersConfig?.[provider]?.name })}</span>
          </div>
        </Button>
      ))}
      <div className="form-email-and-password">
        <strong className="position-relative px-3">{t('or')}</strong>
      </div>
    </div>
  )
}

export default withTransaction('FirebaseConnect', 'component')(FirebaseConnect)
